import React from "react";

import { DateTime } from "@bps/date-time";
import { Text, useTheme } from "@bps/fluent-ui";
import { getDurationSinceNowHumanized } from "@libs/common/common.utils";

import { EMPTY_LABEL, getRootStyles } from "../general-utils";
import { GeneralSection } from "../GeneralSection";

interface GeneralTokenLifeTimeProps {
  tokenExpiryUtc?: DateTime;
}

export const GeneralTokenLifeTime: React.FC<GeneralTokenLifeTimeProps> = ({
  tokenExpiryUtc
}) => {
  const theme = useTheme();

  if (tokenExpiryUtc === undefined) {
    return (
      <GeneralSection heading="Token Lifetime">{EMPTY_LABEL}</GeneralSection>
    );
  }

  const now = DateTime.now();
  const hasExpired = now >= tokenExpiryUtc;

  const humanizedTooltip = getDurationSinceNowHumanized(tokenExpiryUtc);

  const tokenLifetimeLabel =
    hasExpired === true
      ? `Expired ${humanizedTooltip} ago`
      : `Expires in ${humanizedTooltip}`;

  return (
    <GeneralSection heading="Token Lifetime">
      <Text styles={getRootStyles(theme, hasExpired)}>
        {tokenLifetimeLabel}
      </Text>
    </GeneralSection>
  );
};
